import { FC } from "react";
import { Flex, InputNumber, Tooltip } from "antd";
import { priceFormat } from "../../../utils/format";

interface SInputNumberProps {
  value?: string;
  onChange?: (value: string) => Promise<void>;
  placeholder?: string;
  maxTip?: string;
  minTip?: string;
  width?:string;
}

const SInputNumber: FC<SInputNumberProps> = ({
  value,
  onChange,
  placeholder,
  maxTip,
  minTip,
  width,
}) => {

  return (
    <Tooltip
      title={
        <Flex vertical>
          <div>{maxTip}</div>
          <div>{minTip}</div>
        </Flex>
      }
    >
      <InputNumber changeOnWheel
        value={value}
        formatter={(value) => priceFormat(value)}
        min="0"
        max="100000000"
        placeholder={placeholder}
        style={{ width: width ? width :"100%" }}
        changeOnBlur
        stringMode
        onChange={e => onChange && onChange(e ?? '')}
      />
    </Tooltip>
  );
};

export default SInputNumber;
